import { _s } from '@/locale';
import type { SearchLocationWithSlug } from '../types/SearchLocations.types';

export const SEARCH_LOCATIONS = [
  { label: _s('AllSweden'), slug: 'hela-sverige' },
  { label: _s('currentLocation'), slug: 'nara-mig' },
  { label: 'Var', slug: 'var' },
  { label: 'Stockholm', slug: 'stockholm' },
  { label: 'Göteborg', slug: 'goteborg' },
  { label: 'Malmö', slug: 'malmo' },
  { label: 'Uppsala', slug: 'uppsala' },
  { label: 'Västerås', slug: 'vasteras' },
  { label: 'Örebro', slug: 'orebro' },
  { label: 'Linköping', slug: 'linkoping' },
  { label: 'Helsingborg', slug: 'helsingborg' },
  { label: 'Jönköping', slug: 'jonkoping' },
  { label: 'Norrköping', slug: 'norrkoping' },
  { label: 'Lund', slug: 'lund' },
  { label: 'Umeå', slug: 'umea' },
  { label: 'Gävle', slug: 'gavle' },
  { label: 'Borås', slug: 'boras' },
  { label: 'Södertälje', slug: 'sodertalje' },
  { label: 'Eskilstuna', slug: 'eskilstuna' },
  { label: 'Karlstad', slug: 'karlstad' },
  { label: 'Täby', slug: 'taby' },
  { label: 'Sundbyberg', slug: 'sundbyberg' },
  { label: 'Lidingö', slug: 'lidingo' },
  { label: 'Haninge', slug: 'haninge' },
  { label: 'Kungsbacka', slug: 'kungsbacka' },
  { label: 'Solna', slug: 'solna' },
  { label: 'Huddinge', slug: 'huddinge' },
  { label: 'Växjö', slug: 'vaxjo' },
  { label: 'Karlskrona', slug: 'karlskrona' },
  { label: 'Trollhättan', slug: 'trollhattan' },
  { label: 'Luleå', slug: 'lulea' },
  { label: 'Kalmar', slug: 'kalmar' },
  { label: 'Falun', slug: 'falun' },
  { label: 'Skellefteå', slug: 'skelleftea' },
  { label: 'Kristianstad', slug: 'kristianstad' },
  { label: 'Nacka', slug: 'nacka' },
  { label: 'Mölndal', slug: 'molndal' },
  { label: 'Östersund', slug: 'ostersund' },
  { label: 'Sundsvall', slug: 'sundsvall' },
  { label: 'Sollentuna', slug: 'sollentuna' },
  { label: 'Tumba', slug: 'tumba' },
  { label: 'Norrtälje', slug: 'norrtalje' },
  { label: 'Värnamo', slug: 'varnamo' },
  { label: 'Ängelholm', slug: 'angelholm' },
  { label: 'Ystad', slug: 'ystad' },
  { label: 'Motala', slug: 'motala' },
  { label: 'Piteå', slug: 'pitea' },
  { label: 'Trelleborg', slug: 'trelleborg' },
  { label: 'Varberg', slug: 'varberg' },
  { label: 'Nyköping', slug: 'nykoping' },
  { label: 'Åkersberga', slug: 'akersberga' },
  { label: 'Lidköping', slug: 'lidkoping' },
  { label: 'Vallentuna', slug: 'vallentuna' },
  { label: 'Enköping', slug: 'enkoping' },
  { label: 'Falkenberg', slug: 'falkenberg' },
  { label: 'Alingsås', slug: 'alingsas' },
  { label: 'Västervik', slug: 'vastervik' },
  { label: 'Hässleholm', slug: 'hassleholm' },
  { label: 'Bollnäs', slug: 'bollnas' },
  { label: 'Ludvika', slug: 'ludvika' },
  { label: 'Ljungby', slug: 'ljungby' },
  { label: 'Vänersborg', slug: 'vanersborg' },
  { label: 'Nynäshamn', slug: 'nynashamn' },
  { label: 'Södermalm, Stockholm', slug: 'sodermalm-stockholm' },
  { label: 'Vasastaden, Stockholm', slug: 'vasastaden-stockholm' },
  { label: 'Östermalm, Stockholm', slug: 'ostermalm-stockholm' },
  { label: 'Kungsholmen, Stockholm', slug: 'kungsholmen-stockholm' },
  { label: 'Norrmalm, Stockholm', slug: 'norrmalm-stockholm' },
  { label: 'Gamla stan, Stockholm', slug: 'gamla-stan-stockholm' },
  { label: 'Bromma, Stockholm', slug: 'bromma-stockholm' },
  { label: 'Årsta, Stockholm', slug: 'arsta-stockholm' },
  { label: 'Liljeholmen, Stockholm', slug: 'liljeholmen-stockholm' },
  { label: 'Hägersten, Stockholm', slug: 'hagersten-stockholm' },
  { label: 'Skärholmen, Stockholm', slug: 'skarholmen-stockholm' },
  { label: 'Farsta, Stockholm', slug: 'farsta-stockholm' },
  { label: 'Hammarby Sjöstad, Stockholm', slug: 'hammarby-sjostad-stockholm' },
  { label: 'Sickla, Nacka', slug: 'sickla-nacka' },
  { label: 'Centrum, Göteborg', slug: 'centrum-goteborg' },
  { label: 'Vasastaden, Göteborg', slug: 'vasastaden-goteborg' },
  { label: 'Linnéstaden, Göteborg', slug: 'linnestaden-goteborg' },
  { label: 'Majorna, Göteborg', slug: 'majorna-goteborg' },
  { label: 'Haga, Göteborg', slug: 'haga-goteborg' },
  { label: 'Johanneberg, Göteborg', slug: 'johanneberg-goteborg' },
  { label: 'Guldheden, Göteborg', slug: 'guldheden-goteborg' },
  { label: 'Avenyn, Göteborg', slug: 'avenyn-goteborg' },
  { label: 'Hisingen, Göteborg', slug: 'hisingen-goteborg' },
  { label: 'Västra Frölunda, Göteborg', slug: 'vastra-frolunda-goteborg' },
  { label: 'Lindholmen, Göteborg', slug: 'lindholmen-goteborg' },
  { label: 'Eriksberg, Göteborg', slug: 'eriksberg-goteborg' },
  { label: 'Torslanda, Göteborgs Stad', slug: 'torslanda-goteborgs-stad' },
  { label: 'Angered, Göteborg', slug: 'angered-goteborg' },
  { label: 'Västra Hamnen, Malmö', slug: 'vastra-hamnen-malmo' },
  { label: 'Davidshall, Malmö', slug: 'davidshall-malmo' },
  { label: 'Triangeln, Malmö', slug: 'triangeln-malmo' },
  { label: 'Södervärn, Malmö', slug: 'sodervarn-malmo' },
  { label: 'Möllevången, Malmö', slug: 'mollevangen-malmo' },
  { label: 'Limhamn, Malmö', slug: 'limhamn-malmo' },
  { label: 'Slottsstaden, Malmö', slug: 'slottsstaden-malmo' },
  { label: 'Hyllie, Malmö', slug: 'hyllie-malmo' },
  { label: 'Oxie, Malmö kommun', slug: 'oxie-malmo-kommun' },
  // no approval
  { label: 'Upplands Väsby', slug: 'upplands-vasby' },
  { label: 'Stenungsund', slug: 'stenungsund' },
  { label: 'Halmstad', slug: 'halmstad' },
  { label: 'Visby', slug: 'visby' },
  { label: 'Skövde', slug: 'skovde' },
  { label: 'Ulricehamn', slug: 'ulricehamn' },
  { label: 'Gällivare', slug: 'gallivare' },
  { label: 'Eksjö', slug: 'eksjo' },
  { label: 'Märsta', slug: 'marsta' },
  { label: 'Gustavsberg', slug: 'gustavsberg' },
  { label: 'Järfälla', slug: 'jarfalla' },
  { label: 'Tyresö', slug: 'tyreso' },
  { label: 'Ekerö', slug: 'ekero' },
  { label: 'Danderyd', slug: 'danderyd' },
  { label: 'Handen', slug: 'handen' },
  { label: 'Botkyrka kommun', slug: 'botkyrka-kommun' },
] as const;

export type SearchLocationSlug = (typeof SEARCH_LOCATIONS)[number]['slug'];

export const SEARCH_LOCATIONS_OBJECT = SEARCH_LOCATIONS.reduce((map, item) => {
  map[item.slug] = item;
  return map;
}, {} as Record<SearchLocationSlug, SearchLocationWithSlug>);
